export default "__VITE_ASSET__l_Gn2amh__"